import { ComponentMeta, Story } from "@storybook/react";
import React from "react";
import { useTheme } from "styled-components";
import { Flex, Typography } from "../../components";
import { TColor } from "../../types";
import ColorsGroup from "./ColorsGroup";

type TGroupedColors = Record<string, TColor[]>;

const getGroupedColors = (colors: TColor[]): TGroupedColors => {
    const result: TGroupedColors = {};

    colors.forEach(color => {
        const groupName: string = color.match(/([\w-]+)-(\d+|base)/)?.[1] ?? "unknown";

        if (color.includes("base")) result[groupName] = [color, ...(result[groupName] ?? [])];
        else result[groupName] = [...(result[groupName] ?? []), color];
    });

    return result;
};

export default {
    title: "Foundation/Colors Variants"
} as ComponentMeta<any>;

export const Default: Story = () => {
    const {
        v2: { colors }
    } = useTheme();

    const colorsKeys = React.useMemo<TGroupedColors>(() => getGroupedColors(Object.keys(colors) as TColor[]), [colors]);

    return (
        <Flex column spacing={4}>
            <Flex column spacing={0.5}>
                <Typography variant="label-large-semibold" color="text-primary-1200">
                    Color variants
                </Typography>
                <Typography variant="paragraph-regular-regular" color="text-primary-900">
                    Below you can find all available color variants. We use colors to have a clean interface, express
                    our brand and most importantly have a clear communication with our users - providing a smooth and
                    consistent experience. Clicking on a tile will copy a full key for you, so you can quickly paste it
                    into your code.
                </Typography>
            </Flex>
            {Object.entries(colorsKeys).map(([group, groupColors]) => (
                <ColorsGroup key={group} group={group} colors={groupColors} />
            ))}
        </Flex>
    );
};
